import { ExportReportContentContainer } from '~/exportReport/exportReportContent.container';
import { ExportReportPrintPageWrapperComponent } from '~/exportReport/printPage/exportReportPrintPageWrapper.component';
import { useExportReportData } from '~/exportReport/useExportReportData';
import { useExportReportParams } from '~/exportReport/useExportReportParams';
import { useToolsStateExportReportSelector } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.selectors';

export const ExportReportPrintPageContainer = () => {
  const exportReportState = useToolsStateExportReportSelector();
  const { tableColumns } = useExportReportParams();
  const { getDemographicData, getDemographicLabel, isLoading } = useExportReportData({
    tableColumns,
  });

  if (!exportReportState.isActive) {
    return null;
  }

  return (
    <ExportReportPrintPageWrapperComponent reportName={exportReportState.settings.template.name} isLoading={isLoading}>
      <ExportReportContentContainer
        tableColumns={tableColumns}
        getDemographicData={getDemographicData}
        getDemographicLabel={getDemographicLabel}
        // isLoading is intentionally not passed: no loader state is allowed in the printed content.
      />
    </ExportReportPrintPageWrapperComponent>
  );
};
